export default __webpack_public_path__ + "5f957847876a8baef01a16602249cc50.png";